import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
import { verifyPayment } from "../../api/services/paymentService";

/**
 * -------------------------------------------------------
 * PAYMENT RESPONSE PAGE
 * -------------------------------------------------------
 * - Entry point after Cashfree redirect
 * - Reads ONLY order_id from URL
 * - Verifies payment from backend
 * - Redirects based on real status
 */
const PaymentResponsePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const orderId = searchParams.get("order_id");
  const easebuzzResponse = location.state?.easebuzzResponse;

  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    if (!orderId) {
      navigate("/", { replace: true });
      return;
    }

    const verify = async () => {
      try {
        const body = easebuzzResponse ? { easebuzzResponse } : null;
        const res = await verifyPayment(orderId, body);

        if (res.status === "SUCCESS") {
          navigate(`/thank-you?order_id=${res.orderId}`, { replace: true });
          return;
        }

        if (res.status === "FAILED") {
          navigate(`/payment-failed?order_id=${res.orderId}`, { replace: true });
          return;
        }

        // PENDING
        navigate(`/payment-pending?order_id=${res.orderId}`, { replace: true });

      } catch (err) {
        console.error("Payment verification delayed:", err);
        setShowFallback(true);
      }
    };

    verify();
  }, [orderId, navigate, easebuzzResponse]);

  /**
   * -------------------------------------------------------
   * VERIFYING / FALLBACK UI
   * -------------------------------------------------------
   */
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "420px" }}>
        {showFallback ? (
          <Alert variant="warning">
            <strong>We’re still checking your payment</strong>
            <p className="mt-2 mb-2" style={{ fontSize: "0.95rem" }}>
              Sometimes banks take a little longer to respond.
              If you were charged, please don’t try again - your payment will
              be confirmed shortly.
            </p>
            <p style={{ fontSize: "0.9rem", marginBottom: 0 }}>
              If this continues, our support team will be happy to help.
              <br />
              <strong>Email:</strong> info@q2d.in
            </p>
          </Alert>
        ) : (
          <>
            <Spinner animation="border" role="status" />
            <h5 className="mt-3">Verifying Payment</h5>
            <p style={{ color: "#6c757d" }}>
              Please wait while we confirm your payment…
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentResponsePage;
